import Vue from 'vue';
import './prototypes'


import {sync} from 'vuex-router-sync';
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ru-RU'
import Vuex from 'vuex'
import Store from './store'
import App from './app/index.vue'
import VueRouter from 'vue-router';
import routes from './pages';
import VueChart from 'vue-chart-js';

import MaskedInput from 'vue-text-mask'

import 'reset-css';
import './vue'
import './icons'

import './lib/format/_'

import axios from 'axios';
import axiosCancel from 'axios-cancel';
import './dialog'
import './modal'
import './style'
import './components'

axiosCancel(axios, {
  debug: false // default
});

locale.el.upload.deleteTip = 'Для удаления файла нажмите на Delete';
Vue.use(ElementUI, {locale, size: 'mini'});
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueChart);
MaskedInput.render = function (h) {
  let _this = this;
  return h('input', {
    ref: 'input',
    domProps: {
      value: this.value
    },
    on: {
      input: (event) => {
        if (_this.updateValue) _this.updateValue(event.target.value);
      },
      focus: (event) => {
        if (_this.emitEvent) _this.emitEvent(event);
      },
      blur: (event) => {
        if (_this.emitEvent) _this.emitEvent(event);
      },
      keypress: (event) => {
        if (_this.emitEvent) _this.emitEvent(event);
      },
      change: (event) => {
        if (_this.$emit) _this.$emit('change', _this.$refs.input.value);
      },
    }
  })
};
Vue.component('masked-input', MaskedInput);


const store = new Vuex.Store(Store);
const router = new VueRouter({
  routes,
});
sync(store, router);

App.router = router;
App.store = store;
const app = new Vue(App);

window.app = app;


// import './el-theme.scss'

export {
  app,
  router,
  store,
};
